import { defineMessages } from 'react-intl';

export default defineMessages({
  developmentPlans: {
    id: 'pages.pdp.developmentPlans',
    defaultMessage: 'Development Plans',
  },
  title: {
    id: 'pages.pdp.title',
    defaultMessage: 'Personal Development Plan',
  },
  createPDP: {
    id: 'pages.pdp.createPDP',
    defaultMessage: 'Create PDP',
  },
  editPDP: {
    id: 'pages.pdp.editPDP',
    defaultMessage: 'Edit PDP',
  },
  pdpName: {
    id: 'pages.pdp.pdpName',
    defaultMessage: 'PDP Name',
  },
  description: {
    id: 'pages.pdp.description',
    defaultMessage: 'Description',
  },
  careerAspiration: {
    id: 'pages.pdp.careerAspiration',
    defaultMessage: 'Career Aspiration',
  },
  motivationFactors: {
    id: 'pages.pdp.motivationFactors',
    defaultMessage: 'Motivation Factors',
  },
  currentEnergyLevel: {
    id: 'pages.pdp.currentEnergyLevel',
    defaultMessage: 'Current Energy Level',
  },
  currentStrengthAndImprovements: {
    id: 'pages.pdp.currentStrengthAndImprovements',
    defaultMessage: 'Current Strength and Improvements',
  },
  supportRequired: {
    id: 'pages.pdp.supportRequired',
    defaultMessage: 'Support Required',
  },
  developmentNeeds: {
    id: 'pages.pdp.developmentNeeds',
    defaultMessage: 'Development Needs',
  },
  addDevelopmentNeed: {
    id: 'pages.pdp.addDevelopmentNeed',
    defaultMessage: 'Add Development Need',
  },
  developmentNeedName: {
    id: 'pages.pdp.developmentNeedName',
    defaultMessage: 'Development Need Name',
  },
  relatedArea: {
    id: 'pages.pdp.relatedArea',
    defaultMessage: 'Related Area',
  },
  deadline: {
    id: 'pages.pdp.deadline',
    defaultMessage: 'Deadline',
  },
  actionSteps: {
    id: 'pages.pdp.actionSteps',
    defaultMessage: 'Action Steps',
  },
  addActionStep: {
    id: 'pages.pdp.addActionStep',
    defaultMessage: 'Add Action Step',
  },
  actionStepName: {
    id: 'pages.pdp.actionStepName',
    defaultMessage: 'Action Step Name',
  },
  isAchieved: {
    id: 'pages.pdp.isAchieved',
    defaultMessage: 'Achieved',
  },
  requiredTrainings: {
    id: 'pages.pdp.requiredTrainings',
    defaultMessage: 'Required Trainings',
  },
  addTraining: {
    id: 'pages.pdp.addTraining',
    defaultMessage: 'Add Training',
  },
  addRequiredTraining: {
    id: 'pages.pdp.addRequiredTraining',
    defaultMessage: 'Add Required Training',
  },
  trainingName: {
    id: 'pages.pdp.trainingName',
    defaultMessage: 'Training Name',
  },
  trainingStatus: {
    id: 'pages.pdp.trainingStatus',
    defaultMessage: 'Status',
  },
  status: {
    id: 'pages.pdp.status',
    defaultMessage: 'Status',
  },
  draft: {
    id: 'pages.pdp.draft',
    defaultMessage: 'Draft',
  },
  submitted: {
    id: 'pages.pdp.submitted',
    defaultMessage: 'Submitted',
  },
  active: {
    id: 'pages.pdp.active',
    defaultMessage: 'Active',
  },
  completed: {
    id: 'pages.pdp.completed',
    defaultMessage: 'Completed',
  },
  archived: {
    id: 'pages.pdp.archived',
    defaultMessage: 'Archived',
  },
  submit: {
    id: 'pages.pdp.submit',
    defaultMessage: 'Submit for Review',
  },
  approve: {
    id: 'pages.pdp.approve',
    defaultMessage: 'Approve',
  },
  reject: {
    id: 'pages.pdp.reject',
    defaultMessage: 'Reject',
  },
  complete: {
    id: 'pages.pdp.complete',
    defaultMessage: 'Complete',
  },
  archive: {
    id: 'pages.pdp.archive',
    defaultMessage: 'Archive',
  },
  emptyStateTitle: {
    id: 'pages.pdp.emptyStateTitle',
    defaultMessage: 'No Personal Development Plans yet',
  },
  emptyStateDescription: {
    id: 'pages.pdp.emptyStateDescription',
    defaultMessage:
      'Create your first Personal Development Plan to start tracking your growth and development goals.',
  },
  emptyStateNoPlansTitle: {
    id: 'pages.pdp.emptyStateNoPlansTitle',
    defaultMessage: 'There are no Development Plans created yet.',
  },
  emptyStateNoPlansDescription: {
    id: 'pages.pdp.emptyStateNoPlansDescription',
    defaultMessage:
      'You can create your first plan by clicking on "Create Development Plan" button.',
  },
  emptyStateNoPlansInReviewCycleTitle: {
    id: 'pages.pdp.emptyStateNoPlansInReviewCycleTitle',
    defaultMessage:
      'There are no Development Plans in {reviewCycleName} Review Cycle.',
  },
  emptyStateNoPlansInReviewCycleDescription: {
    id: 'pages.pdp.emptyStateNoPlansInReviewCycleDescription',
    defaultMessage:
      'You can create Development Plan by clicking on "Create Development Plan" button.',
  },
  expertise: {
    id: 'pages.pdp.expertise',
    defaultMessage: 'Expertise',
  },
  consultancy: {
    id: 'pages.pdp.consultancy',
    defaultMessage: 'Consultancy',
  },
  leadership: {
    id: 'pages.pdp.leadership',
    defaultMessage: 'Leadership',
  },
  passed: {
    id: 'pages.pdp.passed',
    defaultMessage: 'Passed',
  },
  approved: {
    id: 'pages.pdp.approved',
    defaultMessage: 'Approved',
  },
  requested: {
    id: 'pages.pdp.requested',
    defaultMessage: 'Requested',
  },
  invitedButNotAttended: {
    id: 'pages.pdp.invitedButNotAttended',
    defaultMessage: 'Invited but not attended',
  },
  save: {
    id: 'pages.pdp.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'pages.pdp.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'pages.pdp.delete',
    defaultMessage: 'Delete',
  },
  confirmDelete: {
    id: 'pages.pdp.confirmDelete',
    defaultMessage:
      'Are you sure you want to delete this Personal Development Plan?',
  },
  comments: {
    id: 'pages.pdp.comments',
    defaultMessage: 'Comments',
  },
  addComment: {
    id: 'pages.pdp.addComment',
    defaultMessage: 'Add Comment',
  },
  commentPlaceholder: {
    id: 'pages.pdp.commentPlaceholder',
    defaultMessage: 'Write a comment...',
  },
  filters: {
    id: 'pages.pdp.filters',
    defaultMessage: 'Filters',
  },
  reviewCycle: {
    id: 'pages.pdp.reviewCycle',
    defaultMessage: 'Review Cycle',
  },
  deletePDP: {
    id: 'pages.pdp.deletePDP',
    defaultMessage: 'Delete PDP',
  },
  submitForReview: {
    id: 'pages.pdp.submitForReview',
    defaultMessage: 'Submit for Review',
  },
  approvePDP: {
    id: 'pages.pdp.approvePDP',
    defaultMessage: 'Approve PDP',
  },
  completePDP: {
    id: 'pages.pdp.completePDP',
    defaultMessage: 'Complete PDP',
  },
  archivePDP: {
    id: 'pages.pdp.archivePDP',
    defaultMessage: 'Archive PDP',
  },
  updatedField: {
    id: 'pages.pdp.updatedField',
    defaultMessage:
      '<strong>{field}</strong> updated: <strong>{prev}</strong> → <strong>{curr}</strong>',
  },
  updatedDevelopmentNeed: {
    id: 'pages.pdp.updatedDevelopmentNeed',
    defaultMessage: 'Development Need: <i>{name}</i>{br}',
  },
  updatedActionStep: {
    id: 'pages.pdp.updatedActionStep',
    defaultMessage: 'Action Step: <i>{name}</i>{br}',
  },
  updatedRequiredTraining: {
    id: 'pages.pdp.updatedRequiredTraining',
    defaultMessage: 'Required Training: <i>{name}</i>{br}',
  },
  createdDevelopmentNeed: {
    id: 'pages.pdp.createdDevelopmentNeed',
    defaultMessage: 'Development Need created: <i>{name}</i>{br}',
  },
  deletedDevelopmentNeed: {
    id: 'pages.pdp.deletedDevelopmentNeed',
    defaultMessage: 'Development Need deleted: <i>{name}</i>{br}',
  },
  createdActionStep: {
    id: 'pages.pdp.createdActionStep',
    defaultMessage: 'Action Step created: <i>{name}</i>{br}',
  },
  deletedActionStep: {
    id: 'pages.pdp.deletedActionStep',
    defaultMessage: 'Action Step deleted: <i>{name}</i>{br}',
  },
  createdRequiredTraining: {
    id: 'pages.pdp.createdRequiredTraining',
    defaultMessage: 'Required Training created: <i>{name}</i>{br}',
  },
  deletedRequiredTraining: {
    id: 'pages.pdp.deletedRequiredTraining',
    defaultMessage: 'Required Training deleted: <i>{name}</i>{br}',
  },
  changedStatusTo: {
    id: 'pages.pdp.changedStatusTo',
    defaultMessage: 'Changed status to <status></status>',
  },
  changedStatusFromTo: {
    id: 'pages.pdp.changedStatusFromTo',
    defaultMessage: 'Changed status from <old></old> to <new></new>',
  },
  actionStepCompletionUpdated: {
    id: 'pages.pdp.actionStepCompletionUpdated',
    defaultMessage:
      'Action Step: <i>{name}</i>{br}Status updated: <strong>{prev}</strong> → <strong>{curr}</strong>',
  },
  // Motivation Factors
  motivationFactorCompensation: {
    id: 'pages.pdp.motivationFactorCompensation',
    defaultMessage: 'Compensation',
  },
  motivationFactorCompensationDescription: {
    id: 'pages.pdp.motivationFactorCompensationDescription',
    defaultMessage:
      'I have the opportunity of high financial rewards and worthy compensation for my efforts.',
  },
  teamOfTrust: {
    id: 'pages.pdp.teamOfTrust',
    defaultMessage: 'Team of Trust and open relationships',
  },
  teamOfTrustDescription: {
    id: 'pages.pdp.teamOfTrustDescription',
    defaultMessage:
      'There is a significant degree of close relationships with my teammates which is trustful and open.',
  },
  teamOfProfessionals: {
    id: 'pages.pdp.teamOfProfessionals',
    defaultMessage: 'Team of Professionals',
  },
  teamOfProfessionalsDescription: {
    id: 'pages.pdp.teamOfProfessionalsDescription',
    defaultMessage:
      'I have strong and wide social contacts with my coworkers. They inspire and motivate me to do a quality job.',
  },
  workEnvironment: {
    id: 'pages.pdp.workEnvironment',
    defaultMessage: 'Work Environment',
  },
  workEnvironmentDescription: {
    id: 'pages.pdp.workEnvironmentDescription',
    defaultMessage:
      'Working conditions are comfortable and safe. I have all the needed resources for my productivity right now. I can easily keep my work & life balance.',
  },
  wellStructuredEnvironment: {
    id: 'pages.pdp.wellStructuredEnvironment',
    defaultMessage: 'Well-structured environment',
  },
  wellStructuredEnvironmentDescription: {
    id: 'pages.pdp.wellStructuredEnvironmentDescription',
    defaultMessage:
      'I know what is expected of me within my role. There are transparent rules of the game.',
  },
  recognition: {
    id: 'pages.pdp.recognition',
    defaultMessage: 'Recognition',
  },
  recognitionDescription: {
    id: 'pages.pdp.recognitionDescription',
    defaultMessage:
      'I have enough recognition of my achievements and a sense of accomplishment.',
  },
  challenge: {
    id: 'pages.pdp.challenge',
    defaultMessage: 'Challenge',
  },
  challengeDescription: {
    id: 'pages.pdp.challengeDescription',
    defaultMessage:
      'I can set ambitious goals at work, follow and achieve them.',
  },
  powerImpact: {
    id: 'pages.pdp.powerImpact',
    defaultMessage: 'Power / Impact',
  },
  powerImpactDescription: {
    id: 'pages.pdp.powerImpactDescription',
    defaultMessage:
      'I have opportunity to influence the decisions and to impact other people.',
  },
  changes: {
    id: 'pages.pdp.changes',
    defaultMessage: 'Changes',
  },
  changesDescription: {
    id: 'pages.pdp.changesDescription',
    defaultMessage:
      'I have enough changes and diversity in the work I do, the ability to avoid routine.',
  },
  creativityAutonomy: {
    id: 'pages.pdp.creativityAutonomy',
    defaultMessage: 'Creativity / Autonomy',
  },
  creativityAutonomyDescription: {
    id: 'pages.pdp.creativityAutonomyDescription',
    defaultMessage:
      'I can be creative in implementing new ideas and have enough autonomy to choose my own approach to doing tasks.',
  },
  selfDevelopmentGrowth: {
    id: 'pages.pdp.selfDevelopmentGrowth',
    defaultMessage: 'Self-development / Growth',
  },
  selfDevelopmentGrowthDescription: {
    id: 'pages.pdp.selfDevelopmentGrowthDescription',
    defaultMessage:
      'I feel that I am constantly improving and developing as a professional and personality.',
  },
  usefulMeaningfulJob: {
    id: 'pages.pdp.usefulMeaningfulJob',
    defaultMessage: 'Useful / Meaningful Job',
  },
  usefulMeaningfulJobDescription: {
    id: 'pages.pdp.usefulMeaningfulJobDescription',
    defaultMessage:
      'What I do is in demand and important for me, as well as for the company and society.',
  },
  // Confirmation modal texts
  confirmTitle: {
    id: 'pages.pdp.confirmTitle',
    defaultMessage: 'Confirm',
  },
  confirmSubmitForReviewBody: {
    id: 'pages.pdp.confirmSubmitForReviewBody',
    defaultMessage:
      'Please confirm submitting Development Plan for review by your People Manager. Plan will remain editable for you while People Manager will not approve it.',
  },
  confirmApproveBody: {
    id: 'pages.pdp.confirmApproveBody',
    defaultMessage:
      'Please confirm approving Development Plan. Plan will remain editable only to you, crew member will not be able to adjust the plan after this action.',
  },
  confirmCompleteBody: {
    id: 'pages.pdp.confirmCompleteBody',
    defaultMessage:
      'You are about to complete this Personal Development Plan. After this action, PDP will be not editable anymore.',
  },
  confirmArchiveBody: {
    id: 'pages.pdp.confirmArchiveBody',
    defaultMessage:
      'You are about to archive this Personal Development Plan. After this action, PDP will be not editable anymore.',
  },
  confirmDeleteBody: {
    id: 'pages.pdp.confirmDeleteBody',
    defaultMessage:
      'You are about to delete this Personal Development Plan. After this action, PDP will be not editable anymore.',
  },
});
